import { Badge } from 'react-bootstrap'
import { RebateOfferType } from './tradespend_api'

const OFFER_TYPE_LABELS: Record<RebateOfferType, string> = {
  // Single-product types (global pricing)
  [RebateOfferType.TOTAL_VALUE]: 'Total Value',
  [RebateOfferType.SINGLE_CASE]: 'Single Case',
  [RebateOfferType.PRICE_PER_CASE]: 'Price per Case',
  [RebateOfferType.MINIMUM_ORDER]: 'Minimum Order',
  // Multi-product types (per-product pricing)
  [RebateOfferType.MULTI_PRODUCT_SAVINGS]: 'Savings Offer',
  [RebateOfferType.MULTI_PRODUCT_CASHBACK]: 'Cash Back Offer',
  [RebateOfferType.MULTI_PRODUCT_TRIAL]: 'Trial Offer',
  [RebateOfferType.MULTI_PRODUCT_CUSTOMER_REBATE]: 'Customer Rebate',
  [RebateOfferType.MULTI_PRODUCT_PROGRAM]: 'Rebate Program',
  // Legacy types
  [RebateOfferType.FIRST_OFFER]: 'First Offer',
  [RebateOfferType.TIME_OFFER]: 'Time Offer',
}

interface RebateOfferTypePillProps {
  type: RebateOfferType
}

export function RebateOfferTypePill({ type }: RebateOfferTypePillProps) {
  const label = OFFER_TYPE_LABELS[type]

  // Color mapping based on offer type category
  const getBadgeColor = () => {
    switch (type) {
      // Single-product types
      case RebateOfferType.TOTAL_VALUE:
      case RebateOfferType.SINGLE_CASE:
      case RebateOfferType.PRICE_PER_CASE:
      case RebateOfferType.MINIMUM_ORDER:
        return 'primary'
      // Multi-product types
      case RebateOfferType.MULTI_PRODUCT_SAVINGS:
      case RebateOfferType.MULTI_PRODUCT_CASHBACK:
      case RebateOfferType.MULTI_PRODUCT_TRIAL:
      case RebateOfferType.MULTI_PRODUCT_CUSTOMER_REBATE:
      case RebateOfferType.MULTI_PRODUCT_PROGRAM:
        return 'success'
      // Legacy types
      case RebateOfferType.FIRST_OFFER:
        return 'primary'
      case RebateOfferType.TIME_OFFER:
        return 'info'
      default:
        return 'secondary'
    }
  }

  return <Badge bg={getBadgeColor()}>{label}</Badge>
}
